/** 將 lang_code 轉為 HTTP Accept-Language 值。 */
export function toAcceptLanguage(langCode) {
  if (!langCode) return undefined;
  const code = String(langCode).trim();
  if (!code) return undefined;
  return code.replace('_', '-');
}
